var styles = require('../components/MailListItem.scss');
export default function getBackgroundColorClass(itemProps, tableProps, isChecked) {
    if (itemProps.isSelected || isChecked) {
        return styles.selectedMailListItemColor;
    }
    else if (tableProps.supportsFlagging && itemProps.isFlagged) {
        return styles.flaggedMailListItemColor;
    }
    else if (tableProps.supportsPinning && itemProps.isPinned) {
        return styles.pinnedMailListItemColor;
    }
    else {
        return styles.regularMailListItemColor;
    }
}
//# sourceMappingURL=getBackgroundColorClass.js.map